export interface LeaderboardEntry {
    initials: string;
    score: number;
    lakeName: string;
    createdAt: number;
}

const LEADERBOARD_KEY = "spearfest.leaderboard.v1";
const LEADERBOARD_LIMIT = 10;

export class LeaderboardService {
    static getTopScores(): LeaderboardEntry[] {
        const raw = window.localStorage.getItem(LEADERBOARD_KEY);
        if (!raw) {
            return [];
        }

        try {
            const parsed = JSON.parse(raw) as LeaderboardEntry[];
            return this.sortAndTrim(parsed);
        } catch {
            return [];
        }
    }

    static qualifies(score: number): boolean {
        const board = this.getTopScores();
        if (board.length < LEADERBOARD_LIMIT) {
            return score > 0;
        }
        const minScore = board[board.length - 1]?.score ?? 0;
        return score > minScore;
    }

    static submitScore(initials: string, score: number, lakeName: string): LeaderboardEntry[] {
        const normalizedInitials = this.normalizeInitials(initials);
        const board = this.getTopScores();
        const next: LeaderboardEntry[] = [
            ...board,
            {
                initials: normalizedInitials,
                score: Math.max(0, Math.floor(score)),
                lakeName,
                createdAt: Date.now(),
            },
        ];
        const sorted = this.sortAndTrim(next);
        window.localStorage.setItem(LEADERBOARD_KEY, JSON.stringify(sorted));
        return sorted;
    }

    private static sortAndTrim(entries: LeaderboardEntry[]): LeaderboardEntry[] {
        return [...entries]
            .filter((entry) => Number.isFinite(entry.score) && entry.score >= 0)
            .sort((a, b) => {
                if (b.score !== a.score) {
                    return b.score - a.score;
                }
                return a.createdAt - b.createdAt;
            })
            .slice(0, LEADERBOARD_LIMIT);
    }

    private static normalizeInitials(initials: string): string {
        const clean = initials
            .toUpperCase()
            .replace(/[^A-Z0-9]/g, "")
            .slice(0, 3);
        return clean.padEnd(3, "A");
    }
}
